// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@guestsupply/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

productCarouselProductStyles.productGridContainerStyles = {
    image: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
};

productCarouselProductStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin: 6px 0;
        `,
    },
    erpNumberLabelText: {
        size: 12,
        weight: "bold",
        css: css`
            line-height: 15px;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    erpNumberValueText: {
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        typographyProps: { size: 13 },
    },
};

productCarouselProductStyles.productBadgesWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 12px;
    `,
};

productCarouselProductStyles.productAddToListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
    `,
};

productCarouselProductStyles.productAvailabilityStyles = {
    container: {
        css: css`
            margin-top: 10px;
        `,
    },
};

productCarouselProductStyles.availabilityDeliveryWrapper = {
    css: css`
        display: flex;
    `,
};

productCarouselProductStyles.autoDeliveryStyles = {
    link: {
        css: css`
            margin-top: 7px;
        `,
    },
};
